import React from 'react'
import ReactGA from 'react-ga'

export const LogPath = Component => props => {
  ReactGA.pageview(props.history.location.pathname)

  return <Component {...props} />
}
